import { InMemoryCache } from '@apollo/client'

/**
 * Every policy corresponds to a verified divergence in src/operations.graphql.
 * (The original analysis, docs/apollo-client-audit.md, was removed once fully
 * implemented — see git history.)
 *
 * `merge: true` is needed for types with no `id` (embedded in their parent)
 * that different operations select in divergent shapes; without it each write
 * replaces the object and drops the other operations' fields.
 *
 * Deliberately ABSENT:
 * - `ArAgingInvoice: { keyFields: ['questionFormId'] }` — its amounts depend
 *   on asOfDate, so normalizing would merge rows across differently-dated
 *   reports.
 * - `possibleTypes` — the schema has no unions or interfaces.
 * - `keyArgs`/`merge` for paginated lists — page-based tables want one entry
 *   per page+filter. Revisit only if a list adopts fetchMore.
 * - `defaultOptions` — a global fetch-policy flip has app-wide blast radius.
 */
export const createApolloCache = () =>
  new InMemoryCache({
    typePolicies: {
      // Every selection of QuestionForm.invoice must include id, or that
      // write detaches Invoice back to an embedded object.
      //
      // Payment.status is { status } only in some views; the narrow write
      // must not drop substatus.
      PaymentStatus: { merge: true },
      PaymentSettings: { merge: true },
      // A write that selects only part of the settings (the grid's echo
      // names the buyer object alone) must not wipe the cached fields it
      // leaves out. Merging is shallow per level, so the wrapper and each
      // side need it.
      NotificationSettings: { merge: true },
      MerchantNotificationSetting: { merge: true },
      BuyerNotificationSetting: { merge: true },
      BillData: { merge: true },
    },
  })
